const c = {
  name: "Monaco",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22,0v2.2c1.2,0.4,2,1.5,2,2.8v15.2h-6V12H6v8.2H0V5c0-1.3,0.8-2.4,2-2.8V0h2v2.2C5.2,2.6,6,3.7,6,5v1.7
			c0.2,0,0.4-0.1,0.5-0.1C7.4,6.4,8.3,6.1,9.2,6c0.3-0.8,1-1.5,1.8-1.8V2h2v2.2c0.8,0.3,1.5,1,1.8,1.8c0.9,0.2,1.8,0.4,2.6,0.6
			c0.2,0,0.4,0.1,0.5,0.1V5c0-1.3,0.8-2.4,2-2.8V0H22z M20,9v9.2h2V9H20z M15,10h3V8.8c-0.3-0.1-0.6-0.2-1-0.3
			c-0.6-0.2-1.3-0.3-2-0.5V10z M13,7c0-0.5-0.5-1-1-1s-1,0.5-1,1v3h2V7z M9,8C8.3,8.2,7.6,8.4,7,8.5C6.6,8.6,6.3,8.7,6,8.8V10h3V8z
			 M4,9H2v9.2h2V9z M20,5v2h2V5c0-0.5-0.5-1-1-1S20,4.5,20,5z M3,4C2.5,4,2,4.5,2,5v2h2V5C4,4.5,3.5,4,3,4z"/>
		<path class="st0" d="M14,19.9c-0.6,0.2-1.3,0.3-2,0.3s-1.4-0.1-2-0.3v3.3H8v-4.4c-0.6-0.5-1-1.3-1-2.1c0-1.2,0.7-2.1,1.6-2.6
			c0.9-0.6,2.1-0.9,3.4-0.9s2.5,0.3,3.4,0.9c0.9,0.6,1.6,1.5,1.6,2.6c0,0.9-0.4,1.6-1,2.1v4.4h-2V19.9z M9,16.7
			c0,0.2,0.1,0.6,0.7,0.9c0.5,0.3,1.4,0.6,2.3,0.6s1.8-0.2,2.3-0.6c0.6-0.3,0.7-0.7,0.7-0.9c0-0.2-0.1-0.6-0.7-0.9
			c-0.5-0.3-1.4-0.6-2.3-0.6s-1.8,0.2-2.3,0.6C9.1,16.1,9,16.5,9,16.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Monaco
};
